import axios from 'axios'

const proxyUrl = 'https://proxyapi.digital113.fr/'
const targetUrl = 'https://gestion.digital113.fr/api/v1/carto-ia/'

export default axios.create({
  baseURL: proxyUrl + targetUrl,
})

